<div class="tab-pane" style="z-index:50;position:relative" role="tabpanel" id="propiedad">
    <fieldset id="agregar_propiedad" class="">
        <div class="step_section">
            <h4 class="form-signin-heading"><strong>Informaci&oacute;n Propiedad(<span style="color:red; font-size: 25px">*</span>)</strong></h4>
            <hr>
            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <div>
                        <div class="alert alert-danger" role="alert" id="rol_dir_find_alert" name="rol_dir_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="rol_dir_message"></span>
                        </div>
                        <p>Ingrese Rol o la Direcci&oacute;n (calle y n&uacute;mero) de la propiedad.</p>
                        <div class="form-horizontal">
                            <div class="form-group">

                                <!-- <div class="row" style="margin-left: 0px">
                                    
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Rol" id="rol" name="rol" [formControl]="rol" [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="rol.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <button mat-raised-button color="primary" id="b_rol" [disabled]="!rol.valid" (click)="getPropiedad_rol()">
                                            Buscar Rol
                                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                
                                        </button>
                                    
                                    </div>
                                </div> -->


                                <!--trabajo nuevo-->
                                <div class="row" style="margin-left: 0px">
                                
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <mat-form-field class="example-full-width" style="width: 100%">
                                            <input matInput placeholder="Rol" id="rol" name="rol" [formControl]="rol" [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="rol.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                
                                    <div class="col-sm-12 col-md-2 col-lg-2 text-center">
                                        <button mat-raised-button color="primary" id="b_rol" [disabled]="!rol.valid" (click)="getPropiedad_rol()">
                                            Buscar Rol
                                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        </button>
                                    </div>

                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                        <mat-form-field class="example-full-width" style="width: 100%">
                                            <input type="text" id="PDI_Calle_Nombre" placeholder="Dirección" name="PDI_Calle_Nombre" aria-label="Number"
                                                matInput [formControl]="dir" [matAutocomplete]="auto" [errorStateMatcher]="matcher">
                                            <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-error *ngIf="dir.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>


                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <mat-form-field class="example-full-width" style="width: 100%">
                                            <input matInput placeholder="Número" id="PDI_Num_Calle" name="PDI_Num_Calle" [formControl]="num"
                                                [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="num.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    
                                    <div class="col-sm-12 col-md-3 col-lg-3 text-center">
                                        <button mat-raised-button color="primary" id="b_dir" [disabled]="!dir.valid || !num.valid"
                                            (click)="getPropiedad_dir()">
                                            Buscar Direccion
                                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        </button>
                                    </div>
                                <!--fin trabajo nuevo-->



                                </div>

                                <!-- <div class="row" style="margin-left: 0px">
                                    <label for="rol" class="col-sm-1" style="padding-top: 20px;">Rol</label>
                                    <div class="col-sm-2">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="Rol" id="rol" name="rol" [formControl]="rol" [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="rol.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-3"></div>
                                    <div class="col-sm-2">
                                        <button mat-raised-button color="primary" id="b_rol" [disabled]="!rol.valid" (click)="getPropiedad_rol()">
                                        Buscar Rol 
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                        
                                    </button>
                                        <div class="col-sm-3"></div>
                                    </div>
                                </div> -->

                                <!-- <div class="form-group" style="margin-left: 0px">
                                    <div class="row" style="margin-left: 0px">
                                        <label for="PDI_Calle_Nombre" class="col-sm-1" style="padding-top: 20px;">Direcci&oacute;n</label>
                                        
                                        <div class="col-sm-2" style="padding-right: 10px; padding-left: 10px; width: 150px">
                                            <mat-form-field class="example-full-width">
                                              <input type="text" id="PDI_Calle_Nombre" placeholder="Dirección" name="PDI_Calle_Nombre" aria-label="Number" matInput [formControl]="dir" [matAutocomplete]="auto" [errorStateMatcher]="matcher">
                                              <mat-autocomplete #auto="matAutocomplete">
                                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                                  {{option}}
                                                </mat-option>
                                              </mat-autocomplete>
                                                <mat-error *ngIf="dir.hasError('required')">
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    

                                        <div class="col-sm-2">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Dirección" id="PDI_Calle_Nombre" name="PDI_Calle_Nombre" [formControl]="dir" [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="dir.hasError('required')">
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            </mat-form-field>

                                        </div> 
                                        <div class="col-sm-2" style="padding-right: 10px; margin-left: 40px;">
                                            <mat-form-field class="example-full-width" style="width: 100px;">
                                                <input matInput placeholder="Número" id="PDI_Num_Calle" name="PDI_Num_Calle" [formControl]="num" [errorStateMatcher]="matcher">
                                                <mat-error *ngIf="num.hasError('required')">
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-1"></div>
                                        <div class="col-sm-2" style="padding-left: 10px">
                                            <button mat-raised-button color="primary" id="b_dir" [disabled]="!dir.valid || !num.valid" (click)="getPropiedad_dir()">
                                                Buscar Direccion 
                                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                        </div>
                    </div>

                    <!--Detalle de los propietarios-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>ROL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rol}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>Direccion</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.direccion_completa}} </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>

                                    <span (click)="getPropiedad_por_rol(row.rol, row.id_direcc)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="deletePropiedad(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                    
                </div>

            </div>
        </div>

    </fieldset>
    <!--Material Dialog Modal 1-->
    <!-- <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Direcci&oacute;n</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informaci&oacute;n de la  Direcci&oacute;n</strong><br>
                </div>
                <div class="form-group">
                    <label class="col-md-5 control-label" for="rol" align="left">ROL:</label>
                    <div class="col-md-6">
                        <input  id="rol" name="rol" type="text" placeholder="ROL" [disabled]="rol_dir_encontrada" class="" [(ngModel)]="propiedad.rol">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label class="col-sm-12 col-md-4 col-lg-4 aria-label" for="rol" align="left">ROL:</label>
                        <div class="col-sm-12 col-md-8 col-lg-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="rol" name="rol" type="text" [disabled]="rol_dir_encontrada" class="" [(ngModel)]="propiedad.rol">
                            </mat-form-field>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="folio">Folio:</label>
                    <div class="col-md-6">
                        <input id="folio" name="folio" type="text" placeholder="Folio" [(ngModel)]="propiedad.folio" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- <div class="form-group">
                    <label class="col-md-5 control-label" for="calle" align="left">Calle:</label>
                    <div class="col-md-6">
                        <input id="calle" name="calle" type="text" placeholder="Calle" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.calle" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-5 control-label" for="calle_num" align="left">Numero:</label>
                    <div class="col-md-6">
                        <input id="calle_num" name="calle_num" type="text" placeholder="Numero" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.calle_num" class="form-control input-md">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-4 control-label" for="direc_complemento" align="left">Complemento</label>
                    <div class="col-md-6">
                        <input id="direc_complemento" name="direc_complemento" type="text" placeholder="Direccion Complemento" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.direc_complemento" class="form-control input-md">
                    </div>

                </div>
                <div class="form-group" *ngIf="nombreMuni!='Lo Barnechea'">
                    <div class="col-md-1"></div>
                    <label class="col-md-4 control-label" for="direc_compl_num" align="left">Complem. Numero</label>
                    <div class="col-md-6">
                        <input id="direc_compl_num" name="direc_compl_num" type="text" placeholder="Direccion Compl. Numero" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.direc_compl_num" class="form-control input-md">
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-4 control-label" for="loteo" align="left">Loteo</label>
                    <div class="col-md-6">
                        <input id="loteo" name="loteo" type="text" placeholder="Loteo" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.loteo" class="form-control input-md">
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-4 control-label" for="manzana" align="left">Manzana</label>
                    <div class="col-md-6">
                        <input id="manzana" name="manzana" type="text" placeholder="Manzana" [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.manzana" class="form-control input-md">
                    </div>

                </div> -->
                <!-- <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="plano">Plano</label>
                    <div class="col-md-6">
                        <input id="plano" name="plano" type="text" placeholder="Plano" [(ngModel)]="propiedad.plano " class="form-control input-md">
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="ubicacion">Ubicacion</label>
                    <div class="col-md-6">
                        <input id="ubicacion" name="ubicacion" type="text" placeholder="Plano" [(ngModel)]="propiedad.ubicacion" class="form-control input-md">
                    </div>

                </div> -->
            <!-- </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedad()" [disabled]="!propiedad.rol || !propiedad.calle || !propiedad.calle_num">Ingresar Propiedad <i class="fa fa-user-o" aria-hidden="true"></i></button>
        </mat-dialog-actions>
    </ng-template> -->

    <!--End Material Dialog Modal 1-->


    <!--Material Dialog nuevo Modal 1-->
    <ng-template #openModal>
        
        <mat-dialog-content class="text-center">
            <div class="light-blue darken-3 col-12 p-5">
            <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Direcci&oacute;n</h2>
            
            </div>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informaci&oacute;n de la Direcci&oacute;n</strong><br>
                </div>

                <div class="form-group">
                        
                    <div class="col-sm-12 col-md-12 col-lg-12">
                         <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="rol" name="rol" type="text" [disabled]="rol_dir_encontrada" class="" placeholder="ROL"
                                    [(ngModel)]="propiedad.rol">
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="calle" name="calle" type="text" placeholder="Calle" [disabled]="rol_dir_encontrada"
                                [(ngModel)]="propiedad.calle" class="">
                        </mat-form-field>
                    </div>
                    
                </div>

                <div class="form-group">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="calle_num" name="calle_num" type="text" placeholder="Numero"
                                [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.calle_num" class="">
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="direc_compl_num" name="direc_compl_num" type="text" placeholder="Direccion Compl. Numero"
                                    [disabled]="rol_dir_encontrada" [(ngModel)]="propiedad.direc_compl_num"
                                    class="">
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="loteo" name="loteo" type="text" placeholder="Loteo" [disabled]="rol_dir_encontrada"
                                [(ngModel)]="propiedad.loteo" class="">
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="manzana" name="manzana" type="text" placeholder="Manzana" [disabled]="rol_dir_encontrada"
                                [(ngModel)]="propiedad.manzana" class="">
                        </mat-form-field>
                    </div>
                </div>

            </div>
    
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            
            <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedad()"
                [disabled]="!propiedad.rol || !propiedad.calle ">Ingresar Propiedad <i
                    class="fa fa-home" aria-hidden="true"></i></button>
        </mat-dialog-actions>
    </ng-template>
    
    <!--End Material Dialog nuevo Modal 1-->

    <!-- Material Dialog Modal 2-->
    <ng-template #modalDirecciones>
        <h2 mat-dialog-title> Seleccionar dirección</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe seleccionar una de las direcciones</strong>
                </div>
                <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
                    <div id="search-field" class="top-div">
                        <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
                    </div>
                </div>
                <ul class="list-group">
                    <li class="list-group-item" *ngFor="let direccion of direcciones | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                        <input type="radio" id="direccionSelec" name="direccionSelect" [value]="direccion" name="modal_dir" [(ngModel)]="temp_dir">
                        <span>{{direccion.direccion_completa}}</span>
                    </li>
                </ul>
                <div style="text-align:center">
                    <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_propiet" (click)="savePropiedadMulti(temp_dir)">Ingresar Propiedad <i class="fa fa-user-o" aria-hidden="true"></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog Modal 2-->

    

        <!--Material Dialog Modal No existe ROL-->
        <ng-template #openModalNOROL>
            <h2 mat-dialog-title>Regularice su situación</h2>
            <mat-dialog-content>
               El ROL o dirección que esta buscando no existe, debera regular
               su situación.
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
            </mat-dialog-actions>
        </ng-template>
    
        <!--End Material Dialog Modal No existe ROL-->

    <!--Material Dialog Modal 3-->
    <ng-template #openModalVerPorRol>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Direcci&oacute;n</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informaci&oacute;n de la Direcci&oacute;n</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rol" align="left">ROL (<span style="color: red">*</span>):</label>
                    <div class="col-md-6">
                        <input id="rol" name="rol" type="text" placeholder="ROL" class="form-control input-md" [(ngModel)]="propiedad.rol" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="id_direcc">Id Direccion:</label>
                    <div class="col-md-6">
                        <input id="id_direcc" name="id_direcc" type="text" placeholder="id Direccion" [(ngModel)]="propiedad.id_direcc" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="folio">Folio:</label>
                    <div class="col-md-6">
                        <input id="folio" name="folio" type="text" placeholder="Folio" [(ngModel)]="propiedad.folio" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle" align="left">Calle(<span style="color: red">*</span>):</label>
                    <div class="col-md-6">
                        <input id="calle" name="calle" type="text" placeholder="Calle" [(ngModel)]="propiedad.calle" class="form-control input-md" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="calle_num"align="left">Numero(<span style="color: red">*</span>):</label>
                    <div class="col-md-6">
                        <input id="calle_num" name="calle_num" type="text" placeholder="Numero" [(ngModel)]="propiedad.calle_num" class="form-control input-md" readonly>
                    </div>
                </div>
                <!-- <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direccion_completa">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="direccion_completa" name="direccion_completa" type="text" placeholder="Direccion Completa" [(ngModel)]="propiedad.direccion_completa" class="form-control input-md" readonly>
                    </div>

                </div> -->
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_complemento" align="left">Complemento</label>
                    <div class="col-md-6">
                        <input id="direc_complemento" name="direc_complemento" type="text" placeholder="Direccion Complemento" [(ngModel)]="propiedad.direc_complemento" class="form-control input-md" readonly>
                    </div>

                </div>
                <div class="form-group" *ngIf="nombreMuni!='Lo Barnechea'">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="direc_compl_num" align="left">Complem. Numero</label>
                    <div class="col-md-6">
                        <input id="direc_compl_num" name="direc_compl_num" type="text" placeholder="Direccion Compl. Numero" [(ngModel)]="propiedad.direc_compl_num" class="form-control input-md" readonly>
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="loteo" align="left">Loteo</label>
                    <div class="col-md-6">
                        <input id="loteo" name="loteo" type="text" placeholder="Loteo" [(ngModel)]="propiedad.loteo" class="form-control input-md" readonly>
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="manzana" align="left">Manzana</label>
                    <div class="col-md-6">
                        <input id="manzana" name="manzana" type="text" placeholder="Manzana" [(ngModel)]="propiedad.manzana" class="form-control input-md" readonly>
                    </div>

                </div>
                <!-- <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="plano">Plano</label>
                    <div class="col-md-6">
                        <input id="plano" name="plano" type="text" placeholder="Plano" [(ngModel)]="propiedad.plano" class="form-control input-md" readonly>
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-md-1"></div>
                    <label class="col-md-3 control-label" for="ubicacion">Ubicacion</label>
                    <div class="col-md-6">
                        <input id="ubicacion" name="ubicacion" type="text" placeholder="Plano" [(ngModel)]="propiedad.ubicacion" class="form-control input-md" readonly>
                    </div>

                </div> -->
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Salir</button>
        </mat-dialog-actions>
    </ng-template>

    <!--End Material Dialog Modal 3-->


</div>
<div class="separator"></div>